import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Collapse, IconButton, Typography } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import OpalCard from '../../../opal/OpalCard'

const preStyle = {
  overflow: 'auto',
  maxHeight: 600,
  padding: 12,
  borderRadius: 4,
  backgroundColor: 'var(--opal-surface-secondary, #f5f5f5)',
  fontSize: 12,
  margin: 0
}

function DebugDisplay ({ artifact, title = 'Artifact Data (Debug)' }) {
  const [expanded, setExpanded] = useState(true)

  return (
    <OpalCard className='p-4'>
      <div className='flex items-center justify-between'>
        <div>
          <Typography variant='subtitle1' style={{ fontWeight: 600 }}>
            {title}
          </Typography>
          <Typography variant='caption' color='textSecondary'>
            {artifact.code} &middot; {artifact.startDate} to {artifact.endDate}
          </Typography>
        </div>
        <IconButton size='small' onClick={() => setExpanded(prev => !prev)}>
          {expanded ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </div>

      <Collapse in={expanded}>
        <pre className='mt-3' style={preStyle}>
          {JSON.stringify(artifact.data, null, 2)}
        </pre>
      </Collapse>
    </OpalCard>
  )
}

DebugDisplay.propTypes = {
  artifact: PropTypes.shape({
    artifactId: PropTypes.number,
    code: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    data: PropTypes.any
  }).isRequired,
  title: PropTypes.string
}

export default DebugDisplay
